// PURPOSE: Keep client dates readable beneath the seven-column mobile calendar.
// CONTRACT: Spec 066; read-only links from the authorized Schedule projection.
// DEPENDS: Router and existing design tokens.
// CEILING: No client-side date generation or permission grants.
import { Link } from 'react-router-dom';
import './findtime-schedule.css';

export interface ScheduleDate { id: string; kind: string; date: string; title: string; href: string }
export const scheduleDateLabels: Record<string, string> = { email: 'Email due', followup: 'Follow-up', cadence: 'Cadence call', poll: 'Poll open' };
export function MobileClientDates({ items }: { items: ScheduleDate[] }) {
  const days = [...new Set(items.map(item => item.date))].sort();
  if (!days.length) return null;
  return <section className="schedule-outreach-agenda panel" aria-label="Client dates by day">
    <h2>Client dates</h2>{days.map(day => <div key={day}><h3>{new Date(`${day}T12:00:00Z`).toLocaleDateString(undefined, { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' })}</h3>
      <ul>{items.filter(item => item.date === day).map(item => <li key={item.id}><span>{scheduleDateLabels[item.kind]}</span><Link to={item.href} aria-label={`Open ${item.title}, ${scheduleDateLabels[item.kind]}, ${day}`}>{item.title}</Link></li>)}</ul>
    </div>)}</section>;
}
